import './presentation.less';

import React from 'react';

import Presentation from 'zoomforth_presentation/presentation_root.jsx';

export default ({
  height,
  hasContent,
  slides,
  displayFilename,
  downloadLink,
  canDownloadAsset,
  onDownloadClick,
  onPresentationSlideDisplay
}) => (
  hasContent &&
    <Presentation
      height={height}
      slides={slides}
      shouldIncludeSkipLink={true}
      displayFilename={displayFilename}
      downloadLink={downloadLink}
      canDownloadAsset={canDownloadAsset}
      onDownloadClick={onDownloadClick}
      onSlideDisplay={onPresentationSlideDisplay}
    />
);
